import request, { loginRequest } from '@/utils/request'
import axios, { AxiosResponse } from 'axios'
import store from '@/store'

interface User {
  username: string
  password: string
}

// 获取全局环境变量
const url =
  process.env.NODE_ENV === 'development'
    ? ''
    : `${window.location.protocol}//${window.location.host}`
const envRequest = axios.create({
  baseURL: url,
  timeout: 10000
})

// 用户轨迹查询
const state: any = store.state
const env = state.env.env
const { userInfo } = state.user
const trackRequest = axios.create({
  baseURL: `http://${env === 'dev' ? 'gateway' : 'aligateway'}.${env}.yunexpress.com`,
  timeout: 10000,
  headers: {
    Authorization: userInfo ? `Nebula token:${userInfo.token}` : ''
  }
})

const accounts = '/Sites.SiteAuthorization'
const frontendManagement = '/FrontendManagement'
const menuService = '/portal-frontend'

/**
 * @param data // 登录的账号密码
 * @param type // 身份验证源，值为 LDAP 或者 SYS
 * @param resultType // 为 'key' 时返回 token 字符串
 */
export const login = (data: User, type: string, resultType = ''): Promise<AxiosResponse> => {
  const { username, password } = data

  return loginRequest({
    method: 'POST',
    url: '/Authentication/Authenticate',
    data: {
      $AuthenticationType: 'PasswordCredential',
      Username: username,
      Password: password,
      AuthenticationSource: type
    },
    params: {
      resultType
    }
  })
}

/**
 * 身份验证续期
 * @param key token
 */
export const getAuthentication = (key: string): Promise<AxiosResponse> => {
  return loginRequest({
    method: 'GET',
    url: '/Authentication/GetAuthentication',
    params: {
      key
    }
  })
}

interface dingData {
  code: string
  state: string
}

/**
 * 钉钉登录验证
 * @param data 参数
 */
export const dingLogin = (data: dingData): Promise<AxiosResponse> => {
  const { code, state } = data
  return request({
    method: 'POST',
    url: '/Authentication/Authenticate',
    data: {
      $AuthenticationType: 'CustomAuthenticationCredential',
      Data: {
        code,
        state
      },
      AuthenticationSource: 'DingTalk'
    }
  })
}

interface trackingData {
  TitleName: string
  Url: string
}

/**
 * 用户轨迹查询接口
 * @param data 数据
 */
export const userTracking = (data: trackingData): Promise<AxiosResponse> => {
  return trackRequest({
    method: 'POST',
    url: `${accounts}/User/UserTracking`,
    data
  })
}

/**
 * 获取环境变量
 */
export const getEnvironmentConfig = () => {
  return envRequest({
    method: 'GET',
    url: '/api/agent/Environment/GetConfig'
  })
}

/**
 * 获取登陆平台信息
 */
export const getLoginPlatform = (account?: string) => {
  return request({
    method: 'GET',
    url: `${accounts}/api/Config/GetAmsConfig`,
    params: {
      account
    }
  })
}

/**
 * 获取用户权限菜单列表
 */
// export const getUserMenuList = () => {
//   return request({
//     method: 'GET',
//     url: `${frontendManagement}/user/menu/list`
//   })
// }
export const getUserMenuList = () => {
  return request({
    method: 'GET',
    // 使用ams过来的权限及菜单数据
    url: `${accounts}/user/menu/list`
  })
}

/**
 * 飞书扫码
 * @param RedirectUrl 重定向地址
 */
export const getFeishuUrl = (RedirectUrl: string) => {
  return loginRequest({
    method: 'GET',
    url: '/Authentication/qrcode',
    params: {
      QRCodeSource: 'feishuztmc',
      RedirectUrl
    }
  })
}

/**
 * 获取收藏菜单
 */
export const getCollectMenuList = () => {
  return request({
    method: 'GET',
    url: `${menuService}/user/collectMenu/list`
  })
}

/**
 * 批量取消和收藏菜单
 */
export const batchCollect = (data: any[]) => {
  return request({
    method: 'POST',
    url: `${menuService}/menuUserCollect/batchCollect`,
    data
  })
}
